import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { Link } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import helperNumbers from "../../../helpers/numbers";
import StatusAskTransaction from "./StatusAskTransaction";
import AllTransaction from "./AllTransaction";

export default function InfoAskTransaction() {
  const params = useParams();
  const askTransactionID = params.askTransactionID;

  let askTransaction = AllTransaction.filter(
    (transaction) => transaction.id == askTransactionID
  );
  askTransaction = askTransaction[0];

  const generateAskTransaction = () => {
    let classBadgeStatePage;
    switch (askTransaction.status) {
      case StatusAskTransaction.getStatusAskTransactionString()[
        StatusAskTransaction.statusAskTransaction.PENDING
      ]:
        classBadgeStatePage = "badge-warning";
        break;
      case StatusAskTransaction.getStatusAskTransactionString()[
        StatusAskTransaction.statusAskTransaction.PAID
      ]:
        classBadgeStatePage = "badge-info";
        break;
      case StatusAskTransaction.getStatusAskTransactionString()[
        StatusAskTransaction.statusAskTransaction.REJECT
      ]:
        classBadgeStatePage = "badge-danger";
        break;
    }

    return (
      <div>
        <div className="table-responsive pt-2">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td
                  colSpan={2}
                  className="text-center"
                  style={{ borderRadius: "25px 25px 0 0" }}
                >
                  اطلاعات وارد شده برای درخواست انتقال وجه
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>شماره درخواست</td>
                <td> {helperNumbers.toPersianNum(askTransaction.id)}</td>
              </tr>
              <tr>
                <td>مبلغ (تومان)</td>
                <td>
                  <label className="letter-spacing-finance-number pl-2">
                    {helperNumbers.toPersianNum(
                      helperNumbers.toFormatFinanceNumber(askTransaction.price)
                    )}
                  </label>
                  <label>تومان</label>
                </td>
              </tr>
              <tr>
                <td>نام بانک </td>
                <td>{askTransaction.bank_name}</td>
              </tr>
              <tr>
                <td>نام مالک حساب</td>
                <td>{askTransaction.owner_account_name}</td>
              </tr>
              <tr>
                <td>شماره حساب بانکی</td>
                <td>{askTransaction.account_number}</td>
              </tr>
              <tr>
                <td>شماره کارت بانکی </td>
                <td>{askTransaction.card_number}</td>
              </tr>
              <tr>
                <td>شماره شبا </td>
                <td>{askTransaction.shaba}</td>
              </tr>
              <tr>
                <td>وضعیت</td>
                <td>
                  <span className={`badge ${classBadgeStatePage}`}>
                    {askTransaction.status}
                  </span>
                </td>
              </tr>
              {StatusAskTransaction.getStatusAskTransactionString()[
                StatusAskTransaction.statusAskTransaction.REJECT
              ] == askTransaction.status && (
                <tr>
                  <td>دلیل رد شدن</td>
                  <td> {askTransaction.message}</td>
                </tr>
              )}
              {StatusAskTransaction.getStatusAskTransactionString()[
                StatusAskTransaction.statusAskTransaction.PAID
              ] == askTransaction.status && (
                <>
                  <tr>
                    <td>عکس رسید پرداخت</td>
                    <td>
                      <a
                        target="_blank"
                        href={`${process.env.REACT_APP_DOMAIN}/assets/img/recpiet.webp`}
                      >
                        <img
                          className="img-fluid"
                          src={`${process.env.REACT_APP_DOMAIN}/assets/img/recpiet.webp`}
                        />
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td>تاریخ پرداخت</td>
                    <td>{askTransaction.paid_at}</td>
                  </tr>
                </>
              )}
              <tr>
                <td>تاریخ درج</td>
                <td>{askTransaction.created_at}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="مشاهده وضعیت درخواست انتقال موجودی" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="text-left pb-2">
                <Link
                  className="btn btn-primary"
                  to="/finance/ask-transaction/all"
                >
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i className="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              {generateAskTransaction()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
